import React from "react";

const SHARE_URL = "https://cloud.umami.is/share/pVKBJ4Vw2AEUHTnZ";

function Admin() {
  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <div className="flex items-center justify-between px-4 py-2 bg-white border-b border-gray-200 shadow-sm">
        <span className="text-sm font-bold text-gray-900">סטטיסטיקות המחירון</span>
        <div className="flex items-center gap-3">
          <a
            href={SHARE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-semibold text-gray-500 hover:text-purple-600"
          >
            פתיחה בחלון נפרד
          </a>
          <a
            href="/"
            className="px-3 py-1.5 rounded-full text-xs font-bold bg-purple-600 text-white hover:bg-purple-700 transition-all"
          >
            חזרה למחירון
          </a>
        </div>
      </div>
      <iframe
        src={SHARE_URL}
        title="Umami analytics"
        className="flex-1 w-full border-0"
      />
    </div>
  );
}

export default Admin;
